/* =============================================================================
 * Search Trigger (f01j7bon) — Frido
 *
 * Presentational trigger only. Renders the Figma mobile-menu search pill with
 * the SAME animated placeholder as the ksrgqh2s search drawer input (blinking
 * caret + a rotating term that slides in/out). Tapping opens the existing
 * ksrgqh2s drawer — no search logic is duplicated here.
 *
 * On tap:
 *   1. closes the hamburger drawer (<details id="Details-menu-drawer-container">)
 *   2. clicks the search drawer's trigger (data-target) to open it
 * ============================================================================= */

;(() => {
  if (window.__sai_f01j7bon_initialized__) return
  window.__sai_f01j7bon_initialized__ = true

  const SNIPPET_ID = 'f01j7bon'
  const TAG = 'sai-f01j7bon'
  const FEATURE_SLUG = 'search_trigger'
  const ROTATE_MS = 2200
  const SWAP_MS = 380

  function noopTrack() {}

  function textEscape(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
  }

  if (!customElements.get(TAG)) {
    class SaiSearchTrigger extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return
        this._initialized = true
        this._track = noopTrack
        requestAnimationFrame(() => this._init())
      }

      _init() {
        this._pill = this.querySelector('.sai-f01j7bon__pill')
        this._slot = this.querySelector('.sai-f01j7bon__slot')
        this._target = this.getAttribute('data-target') || '.sai-ksrgqh2s__trigger'
        this._terms = (this.getAttribute('data-terms') || '')
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
        if (!this._pill) return
        this._pill.addEventListener('click', () => this._open())
        this._startRotate()
      }

      setAnalytics(track) {
        this._track = typeof track === 'function' ? track : noopTrack
      }

      applyVariant(content) {
        if (!content) return
        if (content.target_selector) this._target = content.target_selector
        if (typeof content.terms === 'string') {
          const next = content.terms.split(',').map((s) => s.trim()).filter(Boolean)
          if (next.length) {
            this._terms = next
            this._startRotate()
          }
        }
      }

      // Rotating placeholder — mirrors ksrgqh2s _rotatePlaceholder exactly.
      _startRotate() {
        const slot = this._slot
        const terms = this._terms
        if (!slot || terms.length === 0) return
        if (this._timer) {
          clearInterval(this._timer)
          this._timer = null
        }
        this._idx = 0

        const wordHtml = (w) => `<b>'${textEscape(w)}'</b>`
        const showWord = (immediate) => {
          const word = terms[this._idx % terms.length]
          if (immediate) {
            slot.innerHTML = wordHtml(word)
            slot.classList.remove('sai-f01j7bon__slot--out')
            slot.classList.add('sai-f01j7bon__slot--in')
            this._idx++
            return
          }
          slot.classList.remove('sai-f01j7bon__slot--in', 'sai-f01j7bon__slot--enter')
          slot.classList.add('sai-f01j7bon__slot--out')
          setTimeout(() => {
            slot.classList.remove('sai-f01j7bon__slot--out')
            slot.classList.add('sai-f01j7bon__slot--enter')
            slot.innerHTML = wordHtml(word)
            void slot.offsetHeight
            slot.classList.remove('sai-f01j7bon__slot--enter')
            slot.classList.add('sai-f01j7bon__slot--in')
            this._idx++
          }, SWAP_MS)
        }

        showWord(true)
        this._timer = setInterval(() => showWord(false), ROTATE_MS)
      }

      _open() {
        const trigger = document.querySelector(this._target)
        const openSearch = () => {
          if (trigger) trigger.click() // ksrgqh2s._open focuses its input (auto_focus)
        }

        // The hamburger keeps an aggressive focus-trap: while it's open, a
        // focusin listener yanks focus off anything outside it (so the search
        // input can't hold focus / open the keyboard). Horizon only releases
        // the trap after its close animation. So close the hamburger FIRST,
        // then open search once the trap is gone.
        const details = document.getElementById('Details-menu-drawer-container')
        if (details && details.hasAttribute('open')) {
          let opened = false
          const run = () => {
            if (opened) return
            opened = true
            openSearch()
          }
          const drawerEl = details.querySelector('.menu-drawer')
          if (drawerEl) {
            drawerEl.addEventListener('animationend', run, { once: true })
            drawerEl.addEventListener('transitionend', run, { once: true })
          }
          setTimeout(run, 400) // fallback if the close animation event doesn't fire
          const closeBtn = details.querySelector('.menu-drawer__close-button')
          if (closeBtn) closeBtn.click()
          else details.removeAttribute('open')
        } else {
          openSearch()
        }

        this._track(`${FEATURE_SLUG}:open_elem_clicked`, {})
      }
    }

    customElements.define(TAG, SaiSearchTrigger)
  }

  function bindAllContainers() {
    const api = window.__spectrumAi?.snippet
    const containers = document.querySelectorAll(
      `[data-spectrum-instance-id][data-spectrum-snippet-id="${SNIPPET_ID}"]`,
    )
    if (!api?.bind) return
    for (const node of containers) {
      const handles = api.bind(node, ({ variant }) => {
        if (!variant?.content) return
        const root = node.querySelector(TAG)
        if (root && typeof root.applyVariant === 'function') root.applyVariant(variant.content)
      })
      const root = node.querySelector(TAG)
      if (root && handles?.track && typeof root.setAnalytics === 'function') {
        root.setAnalytics(handles.track)
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllContainers, { once: true })
  } else {
    bindAllContainers()
  }
})()
